import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Plus, PartyPopper } from "lucide-react";
import { AppShell } from "../components/AppShell";
import { EventCard } from "../components/EventCard";
import { PageLoader } from "../context/AuthContext";
import { api, formatApiError } from "../lib/api";

const NewButton = () => (
  <Link to="/events/new" data-testid="create-event-button" className="inline-flex items-center gap-2 rounded-lg bg-blue-700 px-6 py-3 font-semibold text-white shadow-lg shadow-blue-600/25 transition-[background-color,transform] duration-200 hover:-translate-y-0.5 hover:bg-blue-800 hover:text-white">
    <Plus className="h-5 w-5" /> New invite
  </Link>
);

export default function Dashboard() {
  const [events, setEvents] = useState(null);

  const load = () =>
    api.get("/events").then((r) => setEvents(r.data)).catch((e) => toast.error(formatApiError(e)));

  useEffect(() => {
    load();
  }, []);

  const remove = async (ev) => {
    try {
      await api.delete(`/events/${ev.id}`);
      toast.success("Event deleted");
      load();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  return (
    <AppShell>
      <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between">
        <div className="rise">
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-blue-700">Host dashboard</p>
          <h1 className="font-display mt-3 text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">Your parties</h1>
        </div>
        <NewButton />
      </div>
      {events === null ? (
        <PageLoader />
      ) : events.length === 0 ? (
        <div data-testid="dashboard-empty-state" className="rise mt-14 rounded-[2rem] border-2 border-dashed border-slate-300 bg-white/70 px-6 py-20 text-center">
          <PartyPopper className="mx-auto h-12 w-12 text-blue-700" />
          <h2 className="font-display mt-5 text-2xl font-bold text-slate-900">No parties yet</h2>
          <p className="mx-auto mt-2 max-w-sm text-slate-500">Create your first invite. It takes about a minute.</p>
          <div className="mt-8 flex justify-center"><NewButton /></div>
        </div>
      ) : (
        <div data-testid="host-events-list" className="mt-12 grid gap-8 md:grid-cols-2 xl:grid-cols-3">
          {events.map((ev, i) => (
            <div key={ev.id} className="rise" style={{ animationDelay: `${i * 70}ms` }}>
              <EventCard event={ev} onDelete={remove} />
            </div>
          ))}
        </div>
      )}
    </AppShell>
  );
}
